import {
	aboutUsHeroImage,
	aboutUsHeroMobileImage,
	adebolaImage,
	missionImage,
	purposeImage,
	adebolaIgeImage,
	julianaIgeImage,
} from "../images";

export const heroData = [
	{
		imageSource: [aboutUsHeroImage, aboutUsHeroMobileImage],
		heading: "About Us",
	},
];

export const welcomeData = [
	{
		imageSource: adebolaImage,
		description: [
			"HeadHeartHand Foundation is a non-profit registered charity located in Surrey, British Columbia, Canada and open to all members of the public. Our focus is to create an enabling environment to promote and teach holistic education in our community focusing on education of the Head, Heart and Hand. The Head focuses on advancement of education to support the growth of intellectual capacity, the Heart focuses on growth of moral/community/civic values and the Hand focuses on advancement of skills required for sustainable community development",
		],
		name: "Adebola Ige",
		post: "President/Founder, HeadHeartHand Foundation",
	},
];

export const missionData = [
	{
		imageSource: missionImage,
		heading: "To promote and teach Holistic Education.",
		subHeading: "Our MISSION",
		description: [
			"We create a sustainable platform and culture that teaches Holistic Education",
			"We develop the intellectual, emotional, moral, social and physical well-being of community members",
		],
		link: "/about-us/our-mission-vision-purpose/our-mission",
	},
	{
		imageSource: purposeImage,
		heading: "Relief Poverty, Advance Education & Moral Values",
		subHeading: "Our PURPOSE",
		description: [
			"Relieve poverty by providing basic necessities of life to the vulnerable members of our communities",
			"Advance education through youth empowerment seminars and training programs",
			"Address specific problems faced by the children, youth and families through support programs",
		],
		link: "/about-us/our-mission-vision-purpose/our-purpose",
	},
];

export const teamData = {
	boards: [
		{
			imageSource: adebolaIgeImage,
			name: "Adebola Ige",
			post: "President/Founder",
			linkedIn: "https://ca.linkedin.com/in/adebola-ige",
		},
		{
			imageSource: julianaIgeImage,
			name: "Juliana Ige",
			post: "Vice President Strategy & Operations/Co-Founder",
			linkedIn: "https://ca.linkedin.com/in/juliana-zigah-b71375115",
		},
	],
	// volunteers: [
	// 	{
	// 		imageSource: femiOgunjiImage,
	// 		name: "Femi Ogunji",
	// 		post: "Lead Program Coordinator (STEM)",
	// 		linkedIn: "https://www.linkedin.com/in/olufemiogunji/",
	// 	},
	// 	{
	// 		imageSource: tomiOdunsiImage,
	// 		name: "Tomi Odunsi",
	// 		post: "Lead Program Coordinator (STEM)",
	// 		linkedIn: "http://linkedin.com/in/tomixin",
	// 	},
	// 	{
	// 		imageSource: adetokunboIgeImage,
	// 		name: "Adetokunbo Ige",
	// 		post: "Lead Project Management Coordinator",
	// 		linkedIn: "https://www.linkedin.com/in/igeadetokunbo/",
	// 	},
	// ],
};

export const programsData = [
	{
		heading: "Basic Necessities Program",
		description:
			"We support vulnerable members of our community by operating a local food bank and providing basic necessities of life such as clothing, ......",
		linkTo: "/about-us/our-programs#0",
	},
	{
		heading: "International Missions Program",
		description:
			"Our International Mission is a relief program to developing nations in cities where the citizens are in need of basic necessities of life, ....",
		linkTo: "/about-us/our-programs#1",
	},
	{
		heading: "BIPOC Scholarship Fund",
		description:
			"This is a scholarship program for BIPOC (Black, Indigenous, and people of color) students attending a vocational/educational institution in Canada/United States, ...",
		linkTo: "/about-us/our-programs#2",
	},
	{
		heading: "GROW Relationship Series",
		description:
			"This is a structured educational program on marital life for intending partners, education for new parents, and relationship growth for married couples...",
		linkTo: "/about-us/our-programs#3",
	},
	{
		heading: "Youth Empowerment Program",
		description:
			"We believe education is a continuous engagement. Our Youth Empowerment Program provides training/workshop to program participants in areas of entrepreneurship  community development, volunteerism, financial literacy and leadership...",
		linkTo: "/about-us/our-programs#4",
	},
	{
		heading: "Relieve conditions associated with disability",
		description:
			"We provide empowerment training and equipment support to individuals with conditions associated with disability...",
		linkTo: "/about-us/our-programs#5",
	},
];
